module.exports = __webpack_public_path__ + "static/media/stairs3.5db062db.png";